import { RouteRecordRaw } from 'vue-router';


const userString = localStorage.getItem("user")
const promoterString = localStorage.getItem("promoter")
const kundeString = localStorage.getItem("kunde")

// console.log("kundeString",kundeString)

let layout="MainLayout.vue"

if(userString!==null){
  // const user = JSON.parse(userString);
  // console.log("Role: ",user.role)
}else if(promoterString!==null){
  // const promoter = JSON.parse(promoterString);
  // console.log("promoter: ",promoter)
  layout="PromoterLayout.vue"
}else if(kundeString!==null){
  // const kunde = JSON.parse(kundeString);
  // console.log("kunde: ",kunde)
  layout="KundeLayout.vue"


}else{
  layout="LoggedOutLayout.vue"
}

console.log("Role layout",layout)



const loggedIn={
        path: '/',
        meta: { requiresAuth: true },
        component: () => import('layouts/'+layout),
      children: [


        { path: '/login/:id_user_for_login?', name:"Login", component: () => import('pages/PromoterLogin.vue') },
        //{ path: '/login/:id_user_for_login?', name:"Login2", component: () => import('pages/Startseite.vue') },
        { path: '', component: () => import('pages/Startseite.vue') },
        { path: '/pdf', component: () => import('pages/Pdf.vue') },
        { path: '/profil', component: () => import('pages/Profil.vue') },
        { path: '/users', component: () => import('pages/Users.vue') },
        { path: '/user/:id_user', component: () => import('pages/User.vue') },
        { path: '/promoters', component: () => import('pages/Promoters.vue') },
        { path: '/promoter/:id_promoter', component: () => import('pages/Promoter.vue') },
        { path: '/promoter/:id_promoter/:tab?', component: () => import('pages/Promoter.vue') },
        { path: '/lagertransaktionen/:id_promotion', component: () => import('pages/Lagertransaktionen.vue') },
        { path: '/unzugeordneteTrials/:id_promotion', component: () => import('pages/UnzugeordneteTrials.vue') },
        { path: '/promotions', component: () => import('pages/Promotions.vue') },
        { path: '/camera', component: () => import('pages/Camera.vue') },
        { path: '/tickets', component: () => import('pages/Tickets.vue') },
        { path: '/ticket/:id_ticket', component: () => import('pages/Ticket.vue') },
        { path: '/promotionort/:id_promotionort/:tab?', component: () => import('pages/PromotionOrt.vue') },
        { path: '/promotion/:id_promotion/:tab?', component: () => import('pages/Promotion.vue') },
        { path: '/einsatz/:id_einsatz/:tab?', component: () => import('pages/Einsatz.vue') },
        { path: '/planungsuebersicht/:id_promotion', component: () => import('pages/Planungsuebersicht.vue') },
        { path: '/tourenplanung/:id_promotion/:id_ort/:datum?', component: () => import('pages/Tourenplanung.vue') },
        { path: '/produkte/:id_promotion', component: () => import('pages/Produkte.vue') },
        { path: '/produkt/:id_promotion/:id_produkt/:tab?', component: () => import('pages/Produkt.vue') },
        { path: '/verkaufsregeln/:id_promotion', component: () => import('pages/Verkaufsregeln.vue') },
        { path: '/verkaufsregel/:id_verkaufsregel', component: () => import('pages/Verkaufsregel.vue') },
        { path: '/promotionpromoter/:id_promotion', component: () => import('pages/PromotionPromoter.vue') },
        { path: '/auftragsnummernsuche/:id_promotion', component: () => import('pages/AuftragsnummernSuche.vue') },
        { path: '/waren/:id_promotion', component: () => import('pages/Waren.vue') },
        { path: '/warenshop/:id_promotion', component: () => import('pages/WarenShop.vue') },
        { path: '/warenbestellungen', component: () => import('pages/WarenBestellungen.vue') },
        { path: '/batTrials/:id_promotion', component: () => import('pages/BatTrials.vue') },
        { path: '/batTrialsSummary/:id_promotion', component: () => import('pages/BatTrialsSummary.vue') },
        { path: '/batTrialsSummaryNachProdukt/:id_promotion', component: () => import('pages/BatTrialsSummaryNachProdukt.vue') },
        { path: '/meinebestellungen/:id_promotion', component: () => import('pages/MeineBestellungen.vue') },
        { path: '/meinebestellung/:id_bestellung', component: () => import('pages/MeineBestellung.vue') },
        { path: '/ware/:id_ware', component: () => import('pages/Ware.vue') },
        { path: '/orte', component: () => import('pages/Orte.vue') },
        { path: '/ort/:id_ort', component: () => import('pages/Ort.vue') },
        { path: '/kunden', component: () => import('pages/Kunden.vue') },
        { path: '/kunde/:id_kunde', component: () => import('pages/Kunde.vue') },
        // { path: '/faxe', component: () => import('pages/Faxe.vue') },
        { path: '/surveys', component: () => import('pages/Surveys.vue') },
        { path: '/survey/:id_survey', component: () => import('pages/Survey.vue') },
        { path: '/charts', component: () => import('pages/Charts.vue') },
        { path: '/kommunikation', component: () => import('pages/Kommunikation.vue') },
        { path: '/permanenteInfo', component: () => import('pages/PermanenteInfo.vue') },
        { path: '/dokumente', component: () => import('pages/Dokumente.vue') },
        { path: '/impressum', component: () => import('pages/Impressum.vue') },
        { path: '/datenschutz',  component: () => import('pages/Datenschutz.vue') },
        { path: '/offeneAuftragsnummern/:id_promotion',  component: () => import('pages/offeneAuftragsnummern.vue') },
        { path: '/nichtFreigegebeneEinsaetze/:id_promotion',  component: () => import('pages/nichtFreigegebeneEinsaetze.vue') },
        { path: '/promoterMitFehlendenDokumenten/:id_promotion',  component: () => import('pages/promoterMitFehlendenDokumenten.vue') },
        { path: '/neueTvppProdukte/:id_promotion',  component: () => import('pages/neueTvppProdukte.vue') },
        { path: '/wechselProdukte/:id_promotion',  component: () => import('pages/wechselProdukte.vue') },
        { path: '/tvppOrders',  component: () => import('pages/TvppOrders.vue') },
        { path: '/todos',  component: () => import('pages/Todos.vue') },
        { path: '/todo/:id_todo',  component: () => import('pages/Todo.vue') },
        { path: '/wikis',  component: () => import('pages/Wikis.vue') },
        { path: '/wiki/:key',  component: () => import('pages/Wiki.vue') },
        { path: '/oktaLogincallback/:idForOktaData', name:"OktaLogin", component: () => import('pages/OktaLoginCallback.vue') },
      ],
    }



    const printRoutes={
      path: '/drucken/:id_promoter',
      meta: { requiresAuth: false },component: () => import('layouts/PrintLayout.vue'),
    }



    const promoterLoggedIn={
     path: '/',
     meta: { requiresPromoterAuth: true },
   component: () => import('layouts/'+layout),
   children: [
    { path: '/feedback', name:"Feedback", component: () => import('pages/promoters/PromoterFeedback.vue') },
    { path: '/phome', name:"PromoterHome", component: () => import('pages/promoters/PromoterHome.vue') },
    { path: '/pbestellungen', name:"PromoterBestellungen", component: () => import('pages/promoters/PromoterBestellungen.vue') },
    { path: '/tagesberichte', name:"Tagesberichte", component: () => import('pages/promoters/PromoterTagesberichte.vue') },
    { path: '/lager', name:"Lager", component: () => import('pages/promoters/PromoterLager.vue') },
    { path: '/promoter/:tab?', component: () =>                   import('pages/promoters/PromoterPromoter.vue') },
     { path: '', component: () =>                           import('pages/promoters/PromoterHome.vue') },
     { path: '/profil', component: () =>                    import('pages/Profil.vue') },
     { path: '/einsatz/:id_einsatz/:tab?', component: () => import('pages/promoters/PromoterEinsatz.vue') },
     { path: '/tickets', component: () => import('pages/promoters/PromoterTickets.vue') },
     { path: '/ticket/:id_ticket', component: () => import('pages/promoters/PromoterTicket.vue') },
     { path: '/tagesberichtupload', component: () => import('pages/promoters/Tagesberichtupload.vue') },
     { path: '/permanenteInfo', component: () => import('pages/promoters/PromoterPermanenteInfo.vue') },
     { path: '/vertraege', component: () => import('pages/promoters/Vertraege.vue') },
     { path: '/impressum', component: () => import('pages/Impressum.vue') },
     { path: '/auftragsnummern', component: () => import('pages/promoters/PromoterAuftragsnummernSuche.vue') },
     { path: '/datenschutz',  component: () => import('pages/Datenschutz.vue') },
     { path: '/login/:id_user_for_login', name:"Login", component: () => import('pages/PromoterLogin.vue') },
     { path: '/register', name:"Register", component: () => import('pages/PromoterRegister.vue') },
     { path: '/oktaLogincallback/:idForOktaData', name:"OktaLogin", component: () => import('pages/OktaLoginCallback.vue') },

   ],
 }

 const kundeLoggedIn={
  path: '/',
  meta: { requiresKundeAuth: true },
component: () => import('layouts/'+layout),
children: [
 { path: '/khome', name:"KundeHome", component: () => import('pages/kunden/KundenHome.vue') },
 { path: '/promotion/:id_promotion/:tab?', component: () => import('pages/kunden/KundenPromotion.vue') },
//  { path: '/batTrialsSummary/:id_promotion', component: () => import('pages/BatTrialsSummary.vue') },
],
}


  const notLoggedIn ={
    path: '/',
    component: () => import('layouts/LoggedOutLayout.vue'),
    children: [
      { path: '/oktaLogincallback/:idForOktaData', name:"OktaLogin", component: () => import('pages/OktaLoginCallback.vue') },
      { path: '/xxx', name:"xxxLogin", component: () => import('pages/PromoterLogin.vue') },
      { path: '/login/:id_user_for_login?', name:"Login", component: () => import('pages/PromoterLogin.vue') },
      { path: '/register', name:"Register", component: () => import('pages/PromoterRegister.vue') },
      { path: '/resetpw/:key', name:"PWReset", component: () => import('pages/PromoterResetPw.vue') },
      { path: '', component: () =>                           import('pages/PromoterLogin.vue') },
      { path: '/mitarbeiterlogin', name:"MitarbeiterLogin", component: () => import('pages/Login.vue') },
      { path: '/kundenlogin', name:"KundenLogin", component: () => import('pages/KundenLogin.vue') },
      { path: '/impressum', name:"impressum", component: () => import('pages/Impressum.vue') },
      { path: '/datenschutz', name:"datenschutz", component: () => import('pages/Datenschutz.vue') },

    ],

  }


  console.log("loggedIn",loggedIn)



  const catchAll = {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue'),
  }

  const  routes: RouteRecordRaw[] = [];


  console.log("layout",layout)
  routes.push(printRoutes)

  if(layout=="MainLayout.vue"){
    routes.push(loggedIn)
  }else if(layout=="PromoterLayout.vue"){
    routes.push(promoterLoggedIn)
  }else if(layout=="LoggedOutLayout.vue"){
    routes.push(notLoggedIn)
  }else if(layout=="KundeLayout.vue"){
    routes.push(kundeLoggedIn)
  }
  //  console.log("layout",layout)
console.log("routes",routes)

routes.push(catchAll)


// console.log("lay routes",routes)
















export default routes;
